import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
const visuallyHiddenStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  white-space: nowrap;\n"])));
const VisuallyHidden = /*#__PURE__*/styled.div.withConfig({
  displayName: "styleHelpers__VisuallyHidden",
  componentId: "sc-1bywdqp-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), visuallyHiddenStyles);
const stretchClickableStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &::after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0);\n  }\n"])));
const Grow = /*#__PURE__*/styled.div.withConfig({
  displayName: "styleHelpers__Grow",
  componentId: "sc-1bywdqp-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"])));
const maxWidthLayoutStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: ", ";\n  margin-left: auto;\n  margin-right: auto;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.page.maxWidth;
});
const MaxWidth = /*#__PURE__*/styled.div.withConfig({
  displayName: "styleHelpers__MaxWidth",
  componentId: "sc-1bywdqp-2"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), maxWidthLayoutStyles);
const SpaceBetweenLayout = /*#__PURE__*/styled.div.withConfig({
  displayName: "styleHelpers__SpaceBetweenLayout",
  componentId: "sc-1bywdqp-3"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.halfSpacing;
});

export { Grow, MaxWidth, SpaceBetweenLayout, VisuallyHidden, maxWidthLayoutStyles, stretchClickableStyles, visuallyHiddenStyles };
